export function buildBaseThemeMapping(m: Record<string, Record<string, string>>) {
	const all: Record<string, Record<string, string>> = {
		// dojo
		'@dojo/widgets/button': m.button,
		'@dojo/widgets/checkbox': m.checkbox,
		'@dojo/widgets/label': m.label,
		'@dojo/widgets/icon': m.icon,
		'@dojo/widgets/tooltip': m.tooltip,
		'@dojo/widgets/radio': m.radio,
		// backview
		'backview/backview': m.backview,
		// card
		'card/expanded': m.expanded,
		'card/tgf': m.tgf,
		// learning-activity
		'learning-activity/activity': m.activity,
		// audio
		'audio/audio': m.audio,
		// video
		'video/video': m.video,
		// lcc-app
		'lcc-app/heading': m.heading,
		'lcc-app/content': m.content,
		'lcc-app/splash': m.splash,
		'lcc-app/footer': m.footer,
		// lcc-rcs
		'lcc-rcs/document': m.document,
		// base-widgets
		'base-widgets/tab-container': m.tabcontainer,
		'base-widgets/accordion2': m.accordion2,
		'base-widgets/sliding-pane': m.slidingpane,
		// book-widgets
		'book-widgets/topicpage': m.topicpage,
		'book-widgets/topicgroup': m.topicgroup,
		'book-widgets/topicaccordion': m.topicaccordion,
		'book-widgets/status-icon': m.statusicon,
		// prepost-viz
		'prepost-viz/prepost-viz': m.prepost,
		'prepost-viz/progress-viz': m.progress,
		// table-of-contents
		'table-of-contents/toc': m.toc,
		'table-of-contents/trigger': m.trigger,
		'table-of-contents/drawer': m.drawer,
		// quiz-widgets
		'quiz-widgets/discussion': m.discussion,
		'quiz-widgets/flashcard': m.flashcard,
		'quiz-widgets/mcquestion': m.mcquestion,
		'quiz-widgets/pretest-review': m.pretestreview,
		'quiz-widgets/prometric-review': m.prometricreview,
		'quiz-widgets/prometric': m.prometric,
		'quiz-widgets/questionfeedback': m.questionfeedback,
		'quiz-widgets/singlestep': m.singlestep,
		'quiz-widgets/quizfolder': m.quizfolder,
		// landing-page
		'landing-page/welcome-view': m.welcomeview,
		'landing-page/general': m.landingpagegeneral,
		// explore-view
		'explore-view/content-order': m.contentorder,
		'explore-view/carousel-view': m.carouselview,
		'explore-view/chooser': m.chooser,
		'explore-view/nav-card': m.navcard
	};
	return Object.fromEntries(Object.entries(all).filter(([, v]) => v !== undefined));
}
